import { Document, PDFViewer } from '@react-pdf/renderer'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Spinner, Label } from "asocomponents"
import LiquidacionService from '../../../../../modules/Liquidacion/application/LiquidacionService'
import CertificadoRetencionGanancias from './CertificadoRetencionGanancias'
import CertificadoRetencionIIBB from './CertificadoRetencionIIBB'
import ComprobanteDetallePagos from './ComprobanteDetallePagos'

export default function VisorPDFCertificadoRetencion() {

  const { idLiquidacion, nroGestion } = useParams()
  const [isLoading, setIsLoading] = useState(true)
  const [existeG, setExisteG] = useState(false)
  const [existeB, setExisteB] = useState(false)
  const [noExisteBG, setNoExisteBG] = useState(false)
  const [datosCertificado, setDatosCertificado] = useState({})
  //#endregion

  //#region funciones

  const cargarDatosCertificado = async (nroGestion) => {
    const liquidacionService = new LiquidacionService()
    const resultCertificado = await liquidacionService.getListReteciones(idLiquidacion, nroGestion)
    setExisteG(resultCertificado.some(item => item.tipoRetencion === "$G"))
    setExisteB(resultCertificado.some(item => item.tipoRetencion === "$B"))
    setNoExisteBG(resultCertificado.some(item => item.tipoRetencion !== "$B" && item.tipoRetencion !== "$G"))
    setDatosCertificado(resultCertificado)
  }
  //#endregion

  //#region useEffect
  useEffect(() => {
    const cargarDatos = async () => {
      try {

        setIsLoading(true)
        await cargarDatosCertificado(nroGestion)
      }
      catch (e) {
        setDatosCertificado(null)
      }
      finally {
        setIsLoading(false)
      }
    };

    cargarDatos()
  }, [])

  //#endregion

  if (isLoading) {
    return <Spinner color="red" size="50" />
  }

  return (
    <div id='root'>
      {datosCertificado ?
        <PDFViewer width={900} height={600}>
          <Document>
            {existeG && <CertificadoRetencionGanancias datosImpresion={datosCertificado} />}
            {existeB && <CertificadoRetencionIIBB datosImpresion={datosCertificado} />}
            {(!existeG && !existeB && noExisteBG) && <ComprobanteDetallePagos datosImpresion={datosCertificado} />}
          </Document>
        </PDFViewer>
        :
        <Label texto="NO SE PUDO GENERAR EL COMPROBANTE. PROBABLEMENTE EL PAGO SE EMITIÓ EL DÍA DE LA CONSULTA. INTENTAR MAÑANA NUEVAMENTE Y DE PERSISITIR EL ERROR, CONTACTARSE CON SU REFERENTE ADMINISTRATIVO" color="text-asociart-intense" />
      }
    </div>
  )
}
